import PropTypes from 'prop-types';

const assessmentRiskPropType = PropTypes.shape({
    id: PropTypes.number,
    risk_name: PropTypes.string,
    risk_description: PropTypes.string,
    company_id: PropTypes.string,
});

export default assessmentRiskPropType;
